import React, { Fragment } from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    ReferenceField,
    Create,
    Edit,
    Show,
    SimpleForm,
    TextInput,
    DateInput,
    ReferenceInput,
    AutocompleteInput,
    required,
    ShowButton,
    EditButton,
    DeleteButton,
    Filter,
    BooleanInput,
    BooleanField,
    useNotify,
    useRefresh,
    useRedirect,
    useUnselectAll,
    useUpdateMany,
    BulkDeleteButton,
    Button,
} from 'react-admin';
import DefaultListActions, { Empty } from "./common";
import moment from 'moment';
import ActiveIcon from "@material-ui/icons/Check";
import DeactivateIcon from "@material-ui/icons/Remove";

const ActivePayrollNoteButton = ({ label, active, selectedIds, loading }) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany] = useUpdateMany(
        'payrollNotes',
        selectedIds,
        { isActive: active },
        {
            onSuccess: () => {
                refresh();
                notify(active ? "Payroll Notes Activated" : "Payroll Notes Deactivated");
                unselectAll('payrollNotes');
            },
            onFailure: error => notify('Error: Payroll Notes not updated', 'warning'),
        }
    );

    return (
        <Button
            label={label}
            onClick={updateMany}
        >
            {active ? <ActiveIcon /> : <DeactivateIcon />}
        </Button>
    );
};

const PayrollNotesBulkActionButtons = props => (
    <Fragment>
        {props.filterValues.isActive && <ActivePayrollNoteButton active={false} label="Deactivate Selected" {...props} />}
        {!props.filterValues.isActive && <ActivePayrollNoteButton active={true} label="Activate Selected" {...props} />}
        <BulkDeleteButton {...props} />
    </Fragment>
);

const PayrollNotesFilter = (props) => (
    <Filter {...props}>
        <BooleanInput source="isActive" alwaysOn />
        <ReferenceInput perPage={1000} label="Employee" source="employeeId" reference="employees">
            <AutocompleteInput allowEmpty={true} optionText={(record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "All Employees"} options={{ type: 'search' }} />
        </ReferenceInput>
        <TextInput source="noteBy" />
        <DateInput source="noteDate" />
        <DateInput source="payrollDate" />
    </Filter>
);

export const PayrollNotesList = props => (
    <List perPage={150} className="all-boarder" bulkActionButtons={<PayrollNotesBulkActionButtons />} exporter={false}
        actions={<DefaultListActions />} empty={<Empty />} filters={<PayrollNotesFilter />}
        filterDefaultValues={{ isActive: true }} {...props}>
        <Datagrid rowClick="show">
            <ReferenceField source="employeeId" reference="employees">
                <TextField source="fullname" />
            </ReferenceField>
            <TextField source="note" />
            <TextField source="noteBy" />
            <DateField source="noteDate" />
            <DateField source="payrollDate" />
            <BooleanField source="isActive" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);

const getInitialValues = () => {
    const userName = localStorage.getItem('user') || 'System';
    return {
        noteBy: userName,
        noteDate: moment().format('YYYY-MM-DD'),
    };
};

export const PayrollNotesCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list" initialValues={getInitialValues()}>
            <ReferenceInput perPage={1000} label="Employee" source="employeeId" reference="employees" validate={[required()]}>
                <AutocompleteInput allowEmpty={true} optionText={(record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "Select Employee"} options={{ type: 'search' }} />
            </ReferenceInput>
            <TextInput source="note" validate={[required()]} multiline rows={4} fullWidth />
            <TextInput source="noteBy" disabled />
            <DateInput source="noteDate" validate={[required()]} />
            <DateInput source="payrollDate" />
            <BooleanInput source="isActive" defaultValue={true} />
        </SimpleForm>
    </Create>
);

export const PayrollNotesEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect="list">
            <ReferenceInput perPage={1000} label="Employee" source="employeeId" reference="employees" validate={[required()]}>
                <AutocompleteInput allowEmpty={true} optionText={(record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "Select Employee"} options={{ type: 'search' }} />
            </ReferenceInput>
            <TextInput source="note" validate={[required()]} multiline rows={4} fullWidth />
            <TextInput source="noteBy" disabled />
            <DateInput source="noteDate" validate={[required()]} />
            <DateInput source="payrollDate" />
            <BooleanInput source="isActive" />
        </SimpleForm>
    </Edit>
);

export const PayrollNotesShow = props => (
    <Show {...props}>
        <SimpleForm>
            <ReferenceField source="employeeId" reference="employees">
                <TextField source="fullname" />
            </ReferenceField>
            <TextField source="note" />
            <TextField source="noteBy" />
            <DateField source="noteDate" />
            <DateField source="payrollDate" />
            <BooleanField source="isActive" />
        </SimpleForm>
    </Show>
);